export const POLO_COLORS = [
  {
    shirt: {
      color: 'orange',
      color2: '<span>o</span><span>r</span><span>a</span><span>n</span><span>g</span><span>e</span>',
      code: 'FF6F1D',
    },
    bg: {
      color: 'blue',
      code: '00819D',
    }
  },
  {
    shirt: {
      color: 'blue',
      color2: '<span>b</span><span>l</span><span>u</span><span>e</span>',
      code: '00819D',
    },
    bg: {
      color: 'pink',
      code: 'DC3855',
    }
  },
  {
    shirt: {
      color: 'pink',
      color2: '<span>p</span><span>i</span><span>n</span><span>k</span>',
      code: 'DC3855',
    },
    bg: {
      color: 'beige',
      code: 'AEA393',
    }
  },
  {
    shirt: {
      color: 'beige',
      color2: '<span>b</span><span>e</span><span>i</span><span>g</span><span>e</span>',
      code: 'AEA393',
    },
    bg: {
      color: 'white',
      code: 'D9D9D9',
    }
  },
  {
    shirt: {
      color: 'white',
      color2: '<span>w</span><span>h</span><span>i</span><span>t</span><span>e</span>',
      code: 'F4F5F0',
    },
    bg: {
      color: 'yellow',
      code: 'FFD400',
    }
  },
  {
    shirt: {
      color: 'yellow',
      color2: '<span>y</span><span>e</span><span>l</span><span>l</span><span>o</span><span>w</span>',
      code: 'FFD400',
    },
    bg: {
      color: 'green',
      code: '007844',
    }
  },
  {
    shirt: {
      color: 'green',
      color2: '<span>g</span><span>r</span><span>e</span><span>e</span><span>n</span>',
      code: '007844',
    },
    bg: {
      color: 'gray',
      code: '868687',
    }
  },
  {
    shirt: {
      color: 'gray',
      color2: '<span>g</span><span>r</span><span>e</span><span>y</span>',
      code: '868687',
    },
    bg: {
      color: 'black',
      code: '2D2C2F',
    }
  },
  {
    shirt: {
      color: 'black',
      color2: '<span>b</span><span>l</span><span>a</span><span>c</span><span>k</span>',
      code: '2D2C2F',
    },
    bg: {
      color: 'darkblue',
      code: '203C7F',
    }
  },
  {
    shirt: {
      color: 'darkblue',
      color2: '<span>d</span><span>a</span><span>r</span><span>k</span><span>b</span><span>l</span><span>u</span><span>e</span>',
      code: '203C7F',
    },
    bg: {
      color: 'orange',
      code: 'FF6F1D',
    }
  },
];

export const POLO_ID = {
  orange: 0,
  blue: 1,
  pink: 2,
  beige: 3,
  white: 4,
  yellow: 5,
  green: 6,
  gray: 7,
  black: 8,
  darkblue: 9,
};

export const POLO_DATA = {
  mens: [
    '262-3160423 ¥11,000',
    'https://store.tsigs.com/PEARLYGATES/pg-poloshirt/2623160423.html'
  ],
  ladies: [
    '263-3160424 ¥11,000',
    'https://store.tsigs.com/PEARLYGATES/pg-poloshirt/2633160424.html'
  ]
};

export const ITEM_DATA = [
  ['CAP', '262-3187400 ¥5,280', 'https://store.tsigs.com/PEARLYGATES/pg-cap-glove/2623187400.html'],
  ['VISOR', '262-3187401 ¥4,950', 'https://store.tsigs.com/PEARLYGATES/pg-cap-glove/2623187401.html'],
  ['SHORTS', '262-3132443 ¥10,450', 'https://store.tsigs.com/PEARLYGATES/pg-shorts/2623132443.html'],
  ['SKIRT', '263-3134422 ¥10,450', 'https://store.tsigs.com/PEARLYGATES/pg-skirt/2633134422.html'],
  ['CART BAG', '262-3181410 ¥6,930', 'https://store.tsigs.com/PEARLYGATES/pg-other/2623181410.html']
];
